import { omit } from 'ramda';

import type { AlineText, TextProps } from '../internal';
import { defaultStyle } from '../internal';

export function createDefaultText(props: Partial<TextProps> = {}, text = ''): AlineText {
  const safeProps = omit(['text'], props);
  return {
    comments: [],
    suggestedEdits: [],
    text,
    ...defaultStyle.styles,
    ...safeProps,
  };
}
